/**
 * 新建 or 编辑工单
 */
import React, { useState, useEffect, useReducer, useRef } from 'react';
import {
  Form,
  Button,
  Select,
  Row,
  Col,
  message,
  Input,
  Spin,
  ConfigProvider,
  TreeSelect,
  Checkbox,
  Upload,
} from 'antd';
import {
  convertListToTree,
  formatToTree,
  propsDragger,
} from '@/utils/common';
import _ from 'lodash';
import zhCN from 'antd/lib/locale/zh_CN';
import Dragger from 'antd/lib/upload/Dragger';
import { InboxOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import {SFuncModal} from "shj-components";
import {getFileUrlPrefix} from "@/services";
import {getWorkerOrderDetail} from "@/services/homeService.ts";
import {iiHOC} from "@/utils/auth.ts";
import arrToListOption from "@/pages/homePage/components/addMatter";
import {checkVipPicturePre} from "@/pages/homePage/components/taskList/components/workDetail.tsx";
import {
  getAllCompanyMrn,
  getTicketsInternalConfig,
  ticketsDetail,
  ticketsSaveOrUpdate
} from "@/services/customerServices.ts";
import {getEmployeeSearchByOrgIdList} from "@/services/channelManagement.ts";
import {isArray} from "lodash-es";

const { TextArea } = Input;

export const ModalAddWorkOrderTab = (props: any) => <ModalAddWorkOrderDom {...props} />;

export function modalAddWorkOrderFn(val: any) {
  const { isEdited } = val;
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: isEdited ? `编辑工单` : `新建工单`,
    width: 1000,
    vanish: true,
    content: (
      <>
        <ConfigProvider locale={zhCN}>
          <ModalAddWorkOrderDom onClose={onClose} {...val} />
        </ConfigProvider>
      </>
    ),
  });
  return dialog;
}

const ModalAddWorkOrderDom = (params: any) => {
  const { onClose, fn, id, issueId, companyCode, isEdited, formOnly } = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const { setFieldsValue } = form;
  const [loading, setLoading] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [isSpecial, setIsSpecial] = useState(false);
  const [fileList, setFileList] = useState([]); // 文件存放地址
  const [classifyId, setClassifyId] = useState<string>();
  const [firstLevelPushQw, setFirstLevelPushQw] = useState(false);
  const [secondLevelPushQw, setSecondLevelPushQw] = useState(false);
  const [threeLevelPushQw, setThreeLevelPushQw] = useState(false);
  const [status, setStatus] = useState(1); //草稿是0，直接派单是1
  const [baseUrl, setBaseUrl] = useState<any>('');

  const [state, dispatch] = useReducer(
    (state, action) => {
      return action;
    },
    {
      getStaffList: [],
      channelTree: [],
      disposePerson: {},
      chargePerson: {},
      firstLevelCopyPerson: [],
      secondLevelCopyPerson: [],
      threeLevelCopyPerson: [],
    },
  );
  useEffect(() => {
    initFn();
  }, []);
  const initFn = async () => {
    setSpinLoading(true);
    const baseUrl = await getFileUrlPrefix();
    const stateObj = {...state}
    setBaseUrl(baseUrl);
    if (isEdited) {
      const data = await Promise.all([ticketsDetail(id)]);
      const _orderList = data[0]?.orderList || {};
      if (!_orderList) {
        return;
      }
      stateObj.firstLevelCopyPerson = _orderList?.firstLevelCopyPersonList
      stateObj.secondLevelCopyPerson = _orderList?.secondLevelCopyPersonList
      stateObj.threeLevelCopyPerson = _orderList?.threeLevelCopyPersonList
      stateObj.chargePerson = _orderList?.chargeVo
      stateObj.disposePerson = _orderList?.disposeVo

      const _classifyId = _orderList['ticketsClassifyList']?.map(item => item.classifyId);
      _orderList['classifyIds'] = _classifyId || null;
      _orderList['firstLevelIsPushMsg'] = _orderList.firstLevelIsPushMsg == 1 ? true : false;
      _orderList['secondLevelIsPushMsg'] = _orderList.secondLevelIsPushMsg == 1 ? true : false;
      _orderList['threeLevelIsPushMsg'] = _orderList.threeLevelIsPushMsg == 1 ? true : false;
      setFirstLevelPushQw(!!_orderList.firstLevelIsPushMsg);
      setSecondLevelPushQw(!!_orderList.secondLevelIsPushMsg);
      setThreeLevelPushQw(!!_orderList.threeLevelIsPushMsg);

      _orderList.firstLevelCopyPerson = _orderList?.firstLevelCopyPersonList?.map((v) => v.ucenterUserId)
      !_orderList.firstLevelCopyPerson && delete _orderList.firstLevelCopyPerson;

      _orderList.secondLevelCopyPerson = _orderList?.secondLevelCopyPersonList?.map((v) => v.ucenterUserId)
      !_orderList.secondLevelCopyPerson && delete _orderList.secondLevelCopyPerson;

      _orderList.threeLevelCopyPerson = _orderList.threeLevelCopyPersonList?.map((v) => v.ucenterUserId);
      !_orderList.threeLevelCopyPerson && delete _orderList.threeLevelCopyPerson;

      _orderList.chargePerson =  _orderList?.chargeVo?.ucenterUserId
      !_orderList.chargePerson && delete _orderList.chargePerson;

      _orderList.disposePerson = _orderList?.disposeVo?.ucenterUserId;
      !_orderList.disposePerson && delete _orderList.disposePerson;

      let ourFiles = _orderList?.files && JSON.parse(_orderList['files']);
      ourFiles =
        _orderList?.files &&
        ourFiles.map((val: any, index: any) => {
          return {
            uid: index,
            name: val.name,
            status: 'done',
            url: checkVipPicturePre(baseUrl, val.path),
            path: val.path,
            type: val.type,
          };
        });
      setFileList(ourFiles || []);
      form.setFieldsValue({ ..._orderList, ...{ file: ourFiles || [] } });
      setSpinLoading(false);
    }

    return new Promise((resolve, reject) => {
      Promise.all([
        getAllCompanyMrn({
          status: true,
          userIdentityFilter: {
            orgId: companyCode
          }
        }),
        getTicketsInternalConfig({data: {}}),
      ])
        .then((resp) => {
          stateObj.getStaffList = resp[0]
          stateObj.channelTree = convertListToTree(resp[1],{pid: 'parentId'})
          dispatch(stateObj);
          setSpinLoading(false);
        })
        .catch((err) => {
          setSpinLoading(false);
        });
    }).catch((err) => {
      setSpinLoading(false);
    });
  };

  const btnStatus = (otherStatus: boolean) => {
    if (isSpecial) {
      return false;
    }
    return otherStatus;
  };

  const onFinish = (status) => {
    if (loading) return;
    form.validateFields().then(values => {
      setLoading(true);
      const _params = { ...values };
      _params['issueId'] = issueId;
      _params['id'] = id;
      _params['status'] = status;
      const {disposePerson, chargePerson, firstLevelCopyPerson, secondLevelCopyPerson, threeLevelCopyPerson} = state
      _params['firstLevelIsPushMsg'] = firstLevelPushQw ? 1 : 0;
      _params['secondLevelIsPushMsg'] = secondLevelPushQw ? 1 : 0;
      _params['threeLevelIsPushMsg'] = threeLevelPushQw ? 1 : 0;

      _params['classifyIds'] = _params['classifyIds'].toString();
      _params['file'] = fileList || [];

      const data = { ..._params,
        classifyIds: _params.classifyIds.split(','),
        disposePerson, chargePerson,firstLevelCopyPerson, secondLevelCopyPerson, threeLevelCopyPerson };
      ticketsSaveOrUpdate(data).then((resp: any) => {
        message.success(resp.message || '操作成功');
        fn && fn();
        onClose();
      })
          .finally(() => {
            setLoading(false);
          });
    })
  };

  const onChangePerson = (data, key) => {
    const newData = isArray(data) ? data.map(item => ({name: item.userName, ucenterUserId: item.ucenterUserId})) : {name: data.userName, ucenterUserId: data.ucenterUserId}
    dispatch({
      ...state,
      [key]: newData
    })
  }

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const { getStaffList, channelTree } = state;
  return iiHOC(
    <SFuncModal.Content
      footer={[<div style={{textAlign: 'right'}}>{!formOnly && (
          <Button
              type="primary"
              onClick={() => {
                onFinish(0)
              }}
              style={{margin: '0 8px'}}
              loading={loading}
          >
            保存草稿
          </Button>
      )}
        <Button
        type="primary"
        onClick={() => {
          onFinish(1)
      }}
      style={{ margin: '0 8px' }}
      loading={loading}
    >
      直接派单
    </Button></div>]}
    >
      <Spin spinning={spinLoading} tip="加载中...">
        <Form
          ref={formNode}
          form={form}
          onFinish={onFinish}
          {...{
            labelCol: {
              xs: { span: 12 },
              sm: { span: 8 },
            },
            wrapperCol: {
              xs: { span: 12 },
              sm: { span: 20 },
            },
          }}
          layout='vertical'
        >
          <Row gutter={2}>
            <Col span={24}>
              <Form.Item
                label="分类"
                name="classifyIds"
                required
                rules={[{ required: true, message: '请选择' }]}
                labelCol={{
                  xs: { span: 4 },
                  sm: { span: 2 },
                }}
                wrapperCol={{
                  xs: { span: 20 },
                  sm: { span: 22 },
                }}
              >
                <TreeSelect
                  showSearch
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder="请选择"
                  allowClear
                  multiple
                    fieldNames={{label: 'name', value: 'id'}}
                  // onChange={onChange}
                  treeData={channelTree}
                  filterTreeNode={(inputValue: any, treeNode: any) => {
                    return treeNode.name.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="处理人" name="disposePerson" required rules={[{ required: true, message: '请选择' }]}>
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  allowClear
                  options={getStaffList}
                  fieldNames={{label: 'userName', value: 'ucenterUserId'}}
                  showSearch
                  onChange={(_, o) => onChangePerson(o, 'disposePerson')}
                  optionFilterProp={'userName'}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="责任人" name="chargePerson">
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  options={getStaffList}
                  fieldNames={{label: 'userName', value: 'ucenterUserId'}}
                  onChange={(_, o) => onChangePerson(o, 'chargePerson')}
                  allowClear
                  showSearch
                  optionFilterProp={'userName'}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="一级抄送人"
                name="firstLevelCopyPerson"
                required
                rules={[{ required: true, message: '请选择' }]}
              >
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  options={getStaffList}
                  fieldNames={{label: 'userName', value: 'ucenterUserId'}}
                  onChange={(_, o) => onChangePerson(o, 'firstLevelCopyPerson')}
                  allowClear
                  showSearch
                  optionFilterProp={'userName'}
                  mode="multiple"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                <Checkbox
                  style={{ marginTop: '30px' }}
                  checked={firstLevelPushQw}
                  onChange={(e) => {
                    setFirstLevelPushQw(e.target.checked);
                  }}
                >
                  是否推送APP消息
                </Checkbox>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="二级抄送人" name="secondLevelCopyPerson">
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  options={getStaffList}
                  fieldNames={{label: 'userName', value: 'ucenterUserId'}}
                  onChange={(_, o) => onChangePerson(o, 'secondLevelCopyPerson')}
                  allowClear
                  showSearch
                  optionFilterProp={'userName'}
                  mode="multiple"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Checkbox
                style={{ marginTop: '30px' }}
                checked={secondLevelPushQw}
                onChange={(e) => {
                  setSecondLevelPushQw(e.target.checked);
                }}
              >
                是否推送APP消息
              </Checkbox>
            </Col>
            <Col span={12}>
              <Form.Item label="三级抄送人" name="threeLevelCopyPerson">
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  options={getStaffList}
                  fieldNames={{label: 'userName', value: 'ucenterUserId'}}
                  onChange={(_, o) => onChangePerson(o, 'threeLevelCopyPerson')}
                  allowClear
                  showSearch
                  optionFilterProp={'userName'}
                  mode="multiple"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Checkbox
                style={{ marginTop: '30px' }}
                checked={threeLevelPushQw}
                onChange={(e) => {
                  setThreeLevelPushQw(e.target.checked);
                }}
              >
                是否推送APP消息
              </Checkbox>
            </Col>
            <Col span={24}>
              <Form.Item
                label="工单描述"
                name="description"
                required
                rules={[{ required: true, message: '请输入' }]}
                labelCol={{
                  xs: { span: 4 },
                  sm: { span: 8 },
                }}
                wrapperCol={{
                  xs: { span: 20 },
                  sm: { span: 22 },
                }}
              >
                <TextArea disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                extra="支持扩展名：.rar .zip .doc .docx .pdf .jpg .png .gif"
                label="上传附件"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                name="file"
                // rules={[{ required: true, message: '成品上传不能为空' }]}
                labelCol={{
                  xs: { span: 4 },
                  sm: { span: 2 },
                }}
                wrapperCol={{
                  xs: { span: 20 },
                  sm: { span: 22 },
                }}
              >
                {/* <Dragger
                  style={{ width: '100%' }}
                  {...propsDragger(fileList, (val: any) => {
                    setFileList(val);
                  })}
                  listType="picture"
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">点击或者拖拽到此区域上传</p>
                  <p className="ant-upload-hint">支持扩展名：.rar .zip .doc .docx .pdf .jpg .png .gif</p>
                </Dragger> */}
                <Upload
                  {...propsDragger({
                    fileList,
                    baseUrl,
                    fn: (val: any) => {
                      setFileList(val);
                    },
                  })}
                  listType="picture-card"
                >
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>选择图片</div>
                  </div>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </SFuncModal.Content>,
  );
};
